import { TimeSlot } from "./time-slot";
import { RadioGroup } from "@headlessui/react";
import { Spinner } from "@/components/ui/spinner";

export const TimeSlots = ({
    onChange,
    value,
    availableTimes,
    availableDaySet,
    isLoading,
}) => {
    if (isLoading) {
        return <Spinner />;
    }

    if (!availableDaySet.size) {
        return <p>No appointments are available for this month.</p>;
    }

    if (availableDaySet.size && !availableTimes.length) {
        return <p>Please select a day</p>;
    }

    return (
        <RadioGroup
            value={value}
            onChange={onChange}
            aria-label="Available times"
            className="grid grid-cols-[repeat(4,max-content)] gap-2"
        >
            {availableTimes.map((availableTime) => (
                <TimeSlot
                    key={availableTime.startDate}
                    value={availableTime.startDate}
                    available={availableTime.available == 1}
                />
            ))}
        </RadioGroup>
    );
};
